// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"9a1b3123","124":"c62514bb","239":"a92b67e2","264":"940efb35","348":"549914b7","453":"46dc3e92","455":"bd0c02a3","480":"663bbfa0","638":"9bcd24e9","659":"a55d3028","738":"9346077c","977":"e77281e4"}[chunkId] + ".chunk.js";
};